import baseURL from "../common/axios";
class Commonservices {
  insert(objinsert) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("ItemMAS/Create", objinsert);
  }
  getdata(HospitalId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get("ItemMAS/List?HospitalId=" + HospitalId);
  }
  Edit(EditID, HospitalId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "ItemMAS/Get?id=" + EditID + "&HospitalId=" + HospitalId
    );
  }
  Delete(DelID) {
    debugger;
    return baseURL.httpMSInventoryUrl.delete("ItemMAS/Delete?id=" + DelID);
  }
  active(DelID, Status) {
    debugger;
    return baseURL.httpMSInventoryUrl.put(
      "ItemMAS/Active?id=" + DelID + "&Status=" + Status + ""
    );
  }
  Update(objupdate) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("ItemMAS/Update", objupdate);
  }
  HSN(HospitalId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get("HSNMAS/List?HospitalId=" + HospitalId);
  }

  OrderingDispensingUnit() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("UnitMAS/List");
  }
  PackageSize() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("PackSizeMAS/List");
  }
  ItemCategory() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("ProductTypeMAS/List");
  }
  ItemGroup() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("GroupMAS/List");
  }
  ItemSubGroup() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("SubGroupMAS/List");
  }
  Manufacture() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("ManufactureMAS/List");
  }
  Generic() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("ItemGenericMAS/List");
  }

  Items() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("ItemMAS/List");
  }

  GetByMultipleProductId(ProductIds, HospitalId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "ItemMAS/GetByMultipleProductId?ProductIds=" + ProductIds + "&HospitalId=" + HospitalId
    );
  }

  GetItems(
    ItemId,
    StoreId,
    BarCodeNo,
    BrandId,
    ModelNumberId,
    SizeId,
    HospitalId,
    BranchId,
    IssueId
  ) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "ItemMAS/GetByItemId?ItemId=" +
      ItemId +
      "&StoreId=" +
      StoreId +
      "&BarCodeNo=" +
      BarCodeNo +
      "&BrandId=" +
      BrandId +
      "&ModelNumberId=" +
      ModelNumberId +
      "&SizeId=" +
      SizeId +
      "&HospitalId=" +
      HospitalId +
      "&BranchId=" +
      BranchId +
      "&IssueId=" +
      IssueId +
      ""
    );
  }
  getAssetItems(StoreId, BranchId, HospitalId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "ItemMAS/ListAssetItemByStoreId?StoreId=" +
      StoreId +
      "&BranchId=" +
      BranchId +
      "&HospitalId=" +
      HospitalId
    );
  }

  GetItemByStoresId(
    FromStoreId,
    ToStoreId,
    ItemName,
    Type,
    SupplierId,
    FromStoreBrMapId,
    ToStoreBrMapId,
    HospitalId
  ) {
    return baseURL.httpMSInventoryUrl.get(
      "ItemMAS/GetItemByStoreId?FromStoreId=" +
      FromStoreId +
      "&ToStoreId=" +
      ToStoreId +
      "&ItemName=" +
      ItemName +
      "&Type=" +
      Type +
      "&SupplierId=" +
      SupplierId +
      "&FromStoreBrMapId=" +
      FromStoreBrMapId +
      "&ToStoreBrMapId=" +
      ToStoreBrMapId +
      "&HospitalId=" +
      HospitalId
    );
  }
  GetItemInStoreById(StoreId, ItemId) {
    return baseURL.httpMSInventoryUrl.get(
      "ItemMAS/GetItemInStoreById?ItemId=" + ItemId + "&StoreId=" + StoreId
    );
  }

  ListItemByStoreId(StoreId, BranchId, HospitalId) {
    return baseURL.httpMSInventoryUrl.get(
      "ItemMAS/ListItemByStoreId?StoreId=" +
      StoreId +
      "&BranchId=" +
      BranchId +
      "&HospitalId=" +
      HospitalId
    );
  }

  ListItemSearchByStoreId(StoreId, BranchId, HospitalId, ItemName) {
    return baseURL.httpMSInventoryUrl.get(
      "ItemMAS/ListItemSearchByStoreId?StoreId=" +
      StoreId +
      "&BranchId=" +
      BranchId +
      "&HospitalId=" +
      HospitalId +
      "&ItemName=" +
      ItemName + ""
    );
  }

    ListItemByStoreIdBranchId(StoreId, BranchId, HospitalId) {
    return baseURL.httpMSInventoryUrl.get(
      "ItemMAS/ListItemByStoreIdBranchId?StoreId=" +
      StoreId +
      "&BranchId=" +
      BranchId +
      "&HospitalId=" +
      HospitalId +
      ""
    );
  }

  ListCustomByStoreId(StoreId, HospitalId) {
    return baseURL.httpMSInventoryUrl.get(
      "ItemMAS/ListCustomByStoreId?StoreId=" + StoreId + "&HospitalId=" + HospitalId
    );
  }

  ListItemByMultipleItemIds(ItemIds) {
    return baseURL.httpMSInventoryUrl.get(
      "ItemMAS/ListItemByMultipleItemIds?ItemIds=" + ItemIds
    );
  }
  GetItemDetails(ItemId, StoreId, BranchId, HospitalId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "ItemMAS/GetItemDetailsByItemId?ItemId=" +
      ItemId +
      "&StoreId=" +
      StoreId +
      "&BranchId=" +
      BranchId +
      "&HospitalId=" +
      HospitalId
    );
  }
  GetLocationDetails(HospitalId, BranchId, ItemId, StoreId, BarCodeNo) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "ItemMAS/GetItemLocationDetails?HospitalId=" +
      HospitalId +
      "&BranchId=" +
      BranchId +
      "&ItemId=" +
      ItemId +
      "&StoreId=" +
      StoreId +
      "&BarCodeNo=" +
      BarCodeNo
    );
  }
  GetStockAdjustDetails(ItemId, StoreId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "ItemMAS/GetStockAdjustDetails?ItemId=" + ItemId + "&StoreId=" + StoreId
    );
  }
  GetItemConfigurationByItemId(HospitalId, BranchId, ItemId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "ItemMAS/GetItemConfigurationByItemId?HospitalId=" +
      HospitalId +
      "&BranchId=" +
      BranchId +
      "&ItemId=" +
      ItemId
    );
  }
  GetByBarCodeId(StoreId, BarCodeNo, HospitalId, BranchId, UOM, Id) {
    return baseURL.httpMSInventoryUrl.get(
      "ItemMAS/GetByBarCodeId?StoreId=" +
      StoreId +
      "&BarCodeNo=" +
      BarCodeNo +
      "&HospitalId=" +
      HospitalId +
      "&BranchId=" +
      BranchId +
      "&UOM=" +
      UOM + "&Id=" + Id
    );
  }

  StockItemList(StoreId, Date, Category, BranchId) {
    debugger;
    //alert("StoreCategoryMapping/StockItemList?StoreId="+ StoreId + "&Date="+Date+"&Category="+Category);
    return baseURL.httpMSInventoryUrl.get(
      "ItemMAS/StockItemList?StoreId=" +
      StoreId +
      "&Date=" +
      Date +
      "&Category=" +
      Category +
      "&BranchId=" + BranchId
    );
  }

  updatebarcodeblock(BarCodeNo, Reason) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("ItemMAS/UpdateBarcodeBlock?BarCodeNo=" + BarCodeNo + "&Reason=" + Reason + "");
  }

  GetItemConfigurationwise() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("ItemMAS/GetItemConfigurationwise");
  }

  GetItemConfigurationByCategoryId(CategoryId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get("ItemMAS/GetItemConfigurationByCategoryId?CategoryId=" + CategoryId);
  }

  CheckstockAvailability(objinsert) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("ItemMAS/CheckStockAvailabilty", objinsert);
  }
  GetItemTrackerDetailsByBarCode(BarCode) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "ItemMAS/GetItemTrackerDetailsByBarCode?BarCode=" + BarCode + ""
    );
  }
  GetSearchByLotNo(ItemName, StoreId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "ItemMAS/GetSearchByLotNo?ItemName=" + ItemName + "&StoreId=" + StoreId + ""
    );
  }
}
export default new Commonservices();
